angular.module('clients')
    .component('clientListFormat', {
        bindings: {
            clients: '<',
            showAll: '<?'
        },
        template: `
            <span class="client-list-formatted" ng-if="$ctrl.clients != null && $ctrl.clients.length>0">
                <a href="#/clients/{{c.id}}" ng-repeat="c in $ctrl.clients track by c.id" ng-if="$ctrl.clients.length<3 || $ctrl.showAll" uib-tooltip="{{c.fullName}}">
                    {{c.symbol}}<span ng-if="!$last">,</span>
                </a>
                <span ng-if="$ctrl.clients != null && $ctrl.clients.length>2 && !$ctrl.showAll">{{$ctrl.clients.length}} firmy - </span>
            </span>
        `,
        controller: function () {
            this.showAll = angular.isDefined(this.showAll) ? this.showAll : true
        }
    })
